import { ServiceAuthConfig } from '../index';

export const BACKEND_AUTH_CONFIG: ServiceAuthConfig = {
    serviceId: 'azure-security-dashboard',
    clientId: process.env.BACKEND_CLIENT_ID || '',
    clientSecret: process.env.BACKEND_CLIENT_SECRET || '',
    scopes: ['read:logs', 'read:security', 'read:identity']
  };